import { COLORS, POST_MESSAGES } from '@/static/global-variables';

let browserName = null;

const forceUpdateColor =  function(color1, color2, browser, toggle) {
    if (browser === "Safari") {
        if(!toggle) {
            color1();
            setTimeout(color2, 100);
        } else {
            color2();
            setTimeout(color1, 100);
        }
    }
};

const toggleGreyText = function(component) {
    return function() {
        component.style.color = COLORS.BUTTON_TEXT_GREY;
    }
};

const toggleBlueText = function(component) {
    return function() {
        component.style.color = COLORS.CANCEL_BLUE;
    }
};

const toggleWhiteText = function(component) {
    return function() {
        component.style.color = COLORS.TEXT_WHITE;
    }
};

const getBrowserNameCached = function(callback) {
    if(!browserName) {
        browserName = callback();
    }
    return browserName;
}

export default {
    getSignatureTotalDistance: function(signatureDrawPoints) {
        let distance = 0;
        if (Array.isArray(signatureDrawPoints)) {
            signatureDrawPoints.forEach(line => {
                if (Array.isArray(line?.points)) {
                    for (let i = 0; i < line.points.length - 1; i++) {
                        const xDiff = Math.pow((line.points[i + 1].x - line.points[i].x), 2)
                        const yDiff = Math.pow((line.points[i + 1].y - line.points[i].y), 2);
                        distance = distance + Math.sqrt(xDiff + yDiff);
                    }
                }
            });
        }
        return distance;
    },
    getSignaturePoints: function(signatureDrawPoints) {
        let length = 0;
        if (Array.isArray(signatureDrawPoints)) {
            signatureDrawPoints.forEach(line => {
                if (Array.isArray(line?.points)) {
                    length += line.points.length;
                }
            });
        }
        return length;
    },
    formatDescription: function(addressObj) {
        if (addressObj.key !== "mail") {
            return addressObj.value;
        }
        else {
            let addressLine3 = addressObj.city || '';
            if (addressObj.city && (addressObj.state || addressObj.zip)) {
                addressLine3 += ', ';
            }
            if (addressObj.state) {
                addressLine3 += addressObj.state + ' ';
            }
            if (addressObj.zip) {
                addressLine3 += addressObj.zip;
            }
            if (addressLine3 && /\S/.test(addressObj.country) && addressObj.country) {
                addressLine3 += ', ';
            }
            if (/\S/.test(addressObj.country) && addressObj.country) {
                addressLine3 += addressObj.country;
            }
            addressLine3.trim();
            return {
                label: addressObj.label,
                location: addressObj.location || '',
                name: addressObj.name || '',
                addressLine2: addressObj["address-line-2"] || '',
                addressLine3: addressLine3
            }
        }
    },
    getViewportBrowserRes: function() {
        return window.innerWidth + " x " + window.innerHeight + " (" + window.outerWidth + " x " + window.outerHeight + ")"
    },
    closePagesIOS: function(message) {
        if(this.isAppleDevice()) {
            setTimeout(() => window.webkit.messageHandlers.closeWebView.postMessage(message), 5000)
        }
    },
    screenSizeMixin: {
        data: function() {
            return {
                isLargeScreen: false
            }
        },
        methods: {
            updateScreen: function() {
                this.$data.isLargeScreen = screen.width > 664;
            }
        },
        mounted: function() {
            this.updateScreen();
            window.addEventListener('resize', this.updateScreen, false);
        }
    },
    isIosUiwebview: function() {
        return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent);
    },
    isAppleDevice: function() {
        return typeof window.webkit !== 'undefined';
    },
    isAndroidDevice: function() {
        return typeof VeevaEngageAndroid !== 'undefined';
    },
    closeSignatureAndroid: function(message = POST_MESSAGES.CLOSE_SIGNATURE_PAGE) {
        VeevaEngageAndroid.handleMessage(message);
    },
    closeSignatureIOS: function(signinId, message = POST_MESSAGES.CLOSE_SIGNATURE_PAGE) {
        if (window.webkit.messageHandlers.closeSignature) {
            window.webkit.messageHandlers.closeSignature.postMessage({
                message: message,
                signinId: signinId
            });
        } else {
            window.parent.postMessage(message, '*');
        }
    },
    triggerRefresh: function(url) {
        document.location.href = url + '/true';
        document.location.reload();
    },
    generateUuid: function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    shouldRenderPadding: function() {
        return document.body.clientHeight + 50 > window.innerHeight;
    },
    forceClearButtonColorChange: function(component, clearActive) {
        //circumvent Safari versions >14 delayed color CSS processing issues
        forceUpdateColor(toggleBlueText(component), toggleGreyText(component), getBrowserNameCached(this.getBrowserName), clearActive);
    },
    forceConfirmButtonColorChange: function(component, disabled) {
        //circumvent Safari versions >14 delayed color CSS processing issues
        forceUpdateColor(toggleWhiteText(component), toggleGreyText(component), getBrowserNameCached(this.getBrowserName), !disabled);
    },
    blankPageRedirect: function() {
        setTimeout(() => {
            window.location.href = 'about:blank';
        }, 15000);
    },
    containCJK: function(input) {
        if (typeof input === 'string') {
            const testString = input.trim();
            const commonCJK = /[\u4e00-\u9fff]/;
            const japaneseNative = /[\u3000-\u303f]|[\u3040-\u309f]|[\u30a0-\u30ff]|[\uff00-\uff9f]/;
            const koreanHangul = /[\uac00-\ud7af]|[\u1100-\u11ff]|[\u3130-\u318f]|[\ua960-\ua97f]|[\ud7b0-\ud7ff]/;
            return commonCJK.test(testString) || japaneseNative.test(testString) || koreanHangul.test(testString);
        }
        return false;
    },
    getBrowserName: function() {
        const ua = navigator.userAgent;
        let tem = null;

        // Specifically targets the WeChat embedded browser from the Windows App
        if (/WindowsWeChat/i.test(ua)) {
            return 'WindowsWeChat';
        }
        // This if statement covers Wechat browser.
        // When you omit this, the normal browser code will return Safari
        // So we want to avoid that case by prioritizing Wechat before any
        // other browser
        if (/micromessenger/i.test(ua)) {
            return 'MicroMessenger';
        }
        if(/UCBrowser/i.test(ua)) {
            return 'UC';
        }
        let matchedUserAgent = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(matchedUserAgent[1]) || /msie/i.test(matchedUserAgent[1])) {
            return 'MSIE';
        }
        if (matchedUserAgent[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem !== null) {
                // When you do the line above, you get an array with three
                // variables, Edge or Opera with the version, Edge or Opera,
                // and the version, respectively.
                return tem[1];
            }
        }
        matchedUserAgent = matchedUserAgent[2] ? [matchedUserAgent[1], matchedUserAgent[2]] : [window.navigator.appName, window.navigator.appVersion, '-?'];
        return matchedUserAgent[0];
    }
}
